import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { Resource } from '~/client/src/desktop/components/Resource'
import {
  IResourceControlsConfig,
  ResourceControlsView,
  RESOURCE_CONTROL_KEYS,
} from '~/client/src/desktop/components/ResourceControls'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import { LocationsProvider } from '~/client/src/desktop/views/Locations/LocationsProvider'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useLocationResourceStore } from '~/client/src/shared/hooks/useLocationResourceStore'
import Localization from '~/client/src/shared/localization/LocalizationManager'

function LocationsControls({ state }: { state?: DesktopInitialState }) {
  const projectId = state?.activeProject?.id || ''
  const userId = state?.user?.id || ''
  const { store } = useLocationResourceStore(projectId || undefined)

  if (!projectId || !userId || !state) {
    return null
  }

  const config: IResourceControlsConfig = {
    ProviderComponent: LocationsProvider,
    controlCommands: store.controls,
    columnConfigKey: LocalStorageKey.LocationsControlsColumnConfig,
    // The generic panel, not a bespoke one: Locations has no custom edit body, so the
    // same card the table opens serves here with its Controls section expanded.
    editPanel: <Resource.EditPanel defaultExpandedSectionId="controls" />,
    labels: {
      countTotal: Localization.translator.xLocations,
      confirmDelete: Localization.translator.confirmDeletionOfLocations,
    },
    ariaLabel: 'Locations controls table',
    // Every control applies to a location: hours of operation, date closures, permitted
    // companies, workflow types and restrictions, showInMap, and the booking limits.
    // Materials narrow this set; locations are the type it was designed around.
    controls: RESOURCE_CONTROL_KEYS,
  }

  return (
    <ResourceControlsView
      config={config}
      projectId={projectId}
      userId={userId}
      state={state}
    />
  )
}

export default inject('state')(observer(LocationsControls))
